import { render, staticRenderFns } from "./cust_tmpl.vue?vue&type=template&id=a8854d58&scoped=true&"
import script from "./cust_tmpl.vue?vue&type=script&lang=js&"
export * from "./cust_tmpl.vue?vue&type=script&lang=js&"
import style0 from "./cust_tmpl.vue?vue&type=style&index=0&id=a8854d58&scoped=true&lang=less&"
import style1 from "./cust_tmpl.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8854d58",
  null
  
)

export default component.exports